// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import {bindActionCreators} from 'redux';
import config from 'config';
import {Link, browserHistory} from 'react-router';
import moment from 'moment';
import {Helmet} from 'react-helmet';
import Linkify from 'react-linkify';

// Modules
import {OverlaySpinner} from 'components/SharedComponents/overlaySpinner';
import {ImageSelector} from 'components/SharedComponents/image-selector';
import {SocialShare} from 'components/SharedComponents/social-share';
import Select from 'components/SharedComponents/form/select';
import {MenuItem, Image} from 'react-bootstrap';
import * as categories from 'components/SharedComponents/categories';
import InlineEdit from 'components/SharedComponents/Inline/inline-edit';
import {MessageBanner} from 'components/SharedComponents/messageBanner';
import {VideoPlayer} from 'components/SharedComponents/video-player';
import RegistrationModal from 'components/watch-now/registration-modal';
// import ThemeSelector from 'components/SharedComponents/themeSelector';

// Redux
import * as HeaderActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/header';
import * as FooterActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/footer';
import * as contentActions from '@getgo/webinar.com-frontend-redux/lib/shared/actions/content';

// Helpers
import {appLogger} from 'app-lib/helpers/logging';
import * as recordingHelper from 'app-lib/helpers/recordingHelper';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';
import * as genericHelper from 'app-lib/helpers/genericHelper';
import PageTracker from 'app-lib/helpers/page-tracker';

const logger = appLogger.create('watch-now');
let contentRecommendedData = null;

import Page from 'src/model/page';

export class WatchNow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            playVideo: false,
            openRegistrationModal: false
        };
        const script = document.createElement('script');
        script.src = config.jwplayer.player;
        script.preload = true;
        document.head.appendChild(script);
    }

    componentDidMount() {
        PageTracker.lastPage = Page.WATCH_NOW;
        this.setHeader();
        if (this.props.channel) {
            mixpanelTracker.setIsChannelPublic(!this.props.channel.isLimitedAudience);
            this.setContentRecommendedData();
            mixpanelTracker.reportWatchNowPageVisit(this.props.params.recordingKey, genericHelper.findQueryValue('source'), genericHelper.findQueryValue('search_id'), contentRecommendedData);
        }
        if (this.props.channel && this.props.channel.channelTheme) {
            this.updateFooter();
        }
        this.props.getOneContent(this.props.params.recordingKey, this.props.isChannelOwner);
        this.props.getContentAttributes(this.props.params.recordingKey, ['description']);
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (nextProps.registrationInfo && nextProps.registrationInfo !== this.props.registrationInfo) {
            this.setState({playVideo: true});
            mixpanelTracker.setUserIdentityForRegisteredUser(nextProps.registrationInfo);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.isChannelOwner && (prevProps.isChannelOwner !== this.props.isChannelOwner)) {
            this.setHeader();
        }

        if (this.props.channel !== prevProps.channel) {
            this.setHeader();
            this.setContentRecommendedData();
            mixpanelTracker.setIsChannelPublic(!this.props.channel.isLimitedAudience);
            mixpanelTracker.reportWatchNowPageVisit(this.props.params.recordingKey, genericHelper.findQueryValue('source'), genericHelper.findQueryValue('search_id'), contentRecommendedData);
            if (this.props.channel && this.props.channel.channelTheme) {
                this.updateFooter();
            }
        }
    }

    componentWillUnmount() {
        this.props.initHeader();
    }

    setThumbnail() {
        const content = this.props.content;
        if (content && content[0]) {
            if (content[0].thumbnail && content[0].thumbnail.cdnLocation) {
                return {backgroundImage: `url(${content[0].thumbnail.cdnLocation})`};
            } else if (content[0].defaultThumbnail && content[0].defaultThumbnail.exist && content[0].defaultThumbnail.cdnLocation) {
                return {backgroundImage: `url(${content[0].defaultThumbnail.cdnLocation})`};
            }
        }
        return {background: 'black'};
    }

    categorySelected(category) {
        const body = {
            category
        };
        const mixpanelAttributes = {category, contentKey: this.props.params.recordingKey};
        (contentRecommendedData) ? mixpanelAttributes.recommendationPayload = contentRecommendedData : null;
        (genericHelper.findQueryValue('search_id')) ? mixpanelAttributes.search_id = genericHelper.findQueryValue('search_id') : null;
        mixpanelTracker.track(`${mixpanelTracker.wnPage}-${mixpanelTracker.categorySelected}`, mixpanelAttributes);
        this.props.createCategory(this.props.params.recordingKey, body);
    }

    setCategory() {
        const {t} = this.props;
        const renderOptions = () => {
            const result = [];
            categories.categoriesArray.forEach((category) => {
                result.push(<MenuItem key={category} eventKey={category} onClick={this.categorySelected.bind(this, category)}>
                    <span><i className="material-icons wn_icon wn_icon__offset--org">{categories.categoriesIcon[category]}</i>{t(`categories.${category}`)}</span></MenuItem>);
            });

            return result;
        };
        if (this.props.isChannelOwner) {
            return (
                <Select
                  id="category"
                  required={true}
                  value={this.props && this.props.content && this.props.content[0].category ? t(`categories.${this.props.content[0].category}`) : t('categories.GENERAL')}
                  placeholder={t('categories.default')}
                  invalid={false}
                >
                    <MenuItem header>{t('categories.default')}</MenuItem>
                    {renderOptions()}
                </Select>
            );
        }
        return (
            <span><i className="material-icons wn_icon wn_icon__offset--attendee">
                {this.props && this.props.content && this.props.content[0].category ? categories.categoriesIcon[this.props.content[0].category] : 'label'}
            </i>{this.props && this.props.content && this.props.content[0].category ? t(`categories.${this.props.content[0].category}`) : t('categories.GENERAL')}</span>
        );
    }

    setDate() {
        let dateString = null;
        if (this.props && this.props.content) {
            dateString = `${recordingHelper.recordingCreatedDate(this.props.content[0].createdTime, 'll')} `;
            return (
                <span><i className="material-icons wn_icon wn_icon__offset--attendee">today</i>{dateString}</span>
            );
        }
        return null;
    }

    editTitle(id, title) {
        const mixpanelAttributes = {contentKey: id, category: this.props.content[0].category};
        (contentRecommendedData) ? mixpanelAttributes.recommendationPayload = contentRecommendedData : null;
        (genericHelper.findQueryValue('search_id')) ? mixpanelAttributes.search_id = genericHelper.findQueryValue('search_id') : null;
        mixpanelTracker.track(`${mixpanelTracker.wnPage}-${mixpanelTracker.recordingTitleChanged}`, mixpanelAttributes);
        const body = {title};
        this.props.editRecordingTitle(id, body);
    }

    setTitle() {
        if (this.props.isChannelOwner) {
            return (
                <InlineEdit
                  t={this.props.t}
                  editText={this.editTitle.bind(this)}
                  text={this.props && this.props.content ? this.props.content[0].title : ''}
                  id={this.props.params.recordingKey}
                  editingElement="textArea"
                  characterCheckRequired={true}
                  regex={/\[|\]|\{|\}+/}
                />
            );
        }
        return (
            <span>{this.props && this.props.content && this.props.content[0].title ? this.props.content[0].title : ''}</span>
        );
    }

    setChannelTitle() {
        return (
            <span>{(this.props.channel && this.props.channel.channelTitle) ? this.props.channel.channelTitle : ''}</span>
        );
    }

    setLogo() {
        const { channel } = this.props;
        return channel && channel.channelLogo && channel.channelLogoCdn ?
            <img src={channel.channelLogoCdn} width="15%" alt="logo" /> : '';
    }

    editDescription(id, description) {
        const mixpanelAttributes = {contentKey: id, category: this.props.content[0].category};
        (contentRecommendedData) ? mixpanelAttributes.recommendationPayload = contentRecommendedData : null;
        (genericHelper.findQueryValue('search_id')) ? mixpanelAttributes.search_id = genericHelper.findQueryValue('search_id') : null;
        mixpanelTracker.track(`${mixpanelTracker.wnPage}-${mixpanelTracker.recordingDescriptionChanged}`, mixpanelAttributes);
        this.props.putContentAttributes(id, {description});
    }

    setDescription() {
        const {t} = this.props;
        if (this.props.isChannelOwner) {
            return (
                <InlineEdit
                  maxlength={1200}
                  minLength={0}
                  t={this.props.t}
                  editText={this.editDescription.bind(this)}
                  text={this.props && this.props.attributes && this.props.attributes.description ? this.props.attributes.description : ''}
                  id={this.props.params.recordingKey}
                  editingElement="textArea"
                  placeholder={t('watchNow.description')}
                  characterCheckRequired={true}
                  regex={/\[|\]|\{|\}+/}
                />
            );
        }
        return (
            <Linkify properties={{target: '_blank', rel: 'nofollow' }} >
                <span>{this.props && this.props.attributes && this.props.attributes.description ? this.props.attributes.description : ''}</span>
            </Linkify>
        );
    }

    // TODO implement themeSelector in next iteration
    themeChangeHandler(color, e) {
    }

    bannerChangeHandler(src) {
    }

    playVideo() {
        // const {identity} = this.props;
        // if (this.props && this.props.content) {
        //     const content = this.props.content[0];
        //     if (content && content.location && content.location.includes('/akamai/')) {
        //         this.playAkamaiRecording(content);
        //     } else if (identity && identity.me && identity.me.name && identity.me.name.givenName && identity.me.name.familyName && identity.me.userName) {
        //         const signinProfile = {
        //             firstName: identity.me.name.givenName,
        //             lastName: identity.me.name.familyName,
        //             email: identity.me.userName
        //         };
        //         this.startContentRegistration(signinProfile);
        //     } else {
        //         this.setState({openRegistrationModal: true});
        //     }
        // }
    }

    playAkamaiRecording(content) {
        const baseUrl = config.broker.g2w.attendee.registration.baseUrl;
        if (content && content.productRefKey) {
            const mixpanelAttributes = {contentKey: content.productRefKey};
            (contentRecommendedData) ? mixpanelAttributes.recommendationPayload = contentRecommendedData : null;
            (genericHelper.findQueryValue('search_id')) ? mixpanelAttributes.search_id = genericHelper.findQueryValue('search_id') : null;
            mixpanelTracker.track(`${mixpanelTracker.wnPage}-${mixpanelTracker.akamaiRecording}`, mixpanelAttributes);
            window.open(`${baseUrl}/recording/${content.productRefKey}`);
        } else {
            logger.error('Unable to play Akamai recording as the content or productRefKey was not found', content);
            browserHistory.push('/internalError');
        }
    }

    videoFrame() {
        let archiveFileKey;
        let s3url;
        const baseUrl = config.app.baseUrl;
        const channelKey = this.props.channel && this.props.channel.channelKey;
        if (this.props.registrationInfo) {
            if (this.props.registrationInfo.archiveFileKey) {
                archiveFileKey = this.props.registrationInfo.archiveFileKey;
            } else {
                archiveFileKey = null;
                logger.error('archivefilekey is null', this.props.registrationInfo);
            }

            if (this.props.registrationInfo.downloadUrl) {
                s3url = this.props.registrationInfo.downloadUrl;
            } else {
                s3url = null;
            }
        }
        if (this.state.playVideo && (archiveFileKey || s3url)) {
            return (<VideoPlayer
              bcID={archiveFileKey} jwUrl={s3url} contentKey={this.props.params.recordingKey}
              contentRecommendedData={contentRecommendedData}
              contentKey={this.props.params && this.props.params.recordingKey}
              title={this.props && this.props.content && this.props.content[0] && this.props.content[0].title}
              url={`${baseUrl}/channel/${channelKey}/recording/${this.props.params.recordingKey}/watch`}
              channelKey={this.props.channel && this.props.channel.channelKey}
              channelName={this.props.channel && this.props.channel.channelTitle}
              identityKey={this.props.identity && this.props.identity.me && this.props.identity.me.id}
              email={this.props.registrationInfo && this.props.registrationInfo.email}
              searchId={genericHelper.findQueryValue('search_id')}
            />);
        }
        return (<div className="wn_content-video" style={this.setThumbnail()} onClick={this.playVideo.bind(this)}>
            <i className="material-icons play-circle">play_circle_filled</i>
            <span className="black-circle"></span>
            <ImageSelector
              t={this.props.t}
              show={this.props.isChannelOwner ? this.props.isChannelOwner : null}
              clickHandler={this.thumbnailChangeHandler.bind(this)}
              deleteThumbnail={this.deleteThumbnail.bind(this)}
              details={this.props.content ? this.props.content[0] : ''}
            />
        </div>);
    }

    registrationDetails(signinProfile) {
        const mixpanelAttributes = {
            contentKey: this.props.params.recordingKey,
            category: this.props.content[0].category
        };
        (contentRecommendedData) ? mixpanelAttributes.recommendationPayload = contentRecommendedData : null;
        (genericHelper.findQueryValue('search_id')) ? mixpanelAttributes.search_id = genericHelper.findQueryValue('search_id') : null;
        mixpanelTracker.track(`${mixpanelTracker.wnPage}-${mixpanelTracker.registerButtonClicked}`, mixpanelAttributes);
        this.startContentRegistration(signinProfile);
        this.setState({openRegistrationModal: false});
    }

    startContentRegistration(signinProfile) {
        if (this.props.content && this.props.content[0] && this.props.content[0].productRefKey) {
            this.props.registerForContent(this.props.content[0].productRefKey, signinProfile);
        }
    }

    showRegistrationModal() {
        const onExited = () => {
            this.setState({openRegistrationModal: false});
        };
        if (this.state.openRegistrationModal) {
            return (
                <RegistrationModal
                  onExited={onExited.bind(this)}
                  t={this.props.t}
                  registrationData={this.registrationDetails.bind(this)}
                  attendeeInfo={this.props.attendeeInfo}
                />);
        }
        return null;
    }

    thumbnailChangeHandler(thumbnailUrl, Blobs) {
        const mixpanelAttributes = {contentKey: this.props.content[0].id, category: this.props.content[0].category};
        (contentRecommendedData) ? mixpanelAttributes.recommendationPayload = contentRecommendedData : null;
        (genericHelper.findQueryValue('search_id')) ? mixpanelAttributes.search_id = genericHelper.findQueryValue('search_id') : null;
        mixpanelTracker.track(`${mixpanelTracker.wnPage}-${mixpanelTracker.thumbnailImageUploaded}`, mixpanelAttributes);
        const body = {
            fileName: Blobs[0].filename,
            fileType: Blobs[0].mimetype,
            size: Blobs[0].size,
            location: thumbnailUrl,
            fileWidth: Blobs[0].cropped.cropArea.size[0],
            fileHeight: Blobs[0].cropped.cropArea.size[1]
        };
        this.props.createThumbnail(this.props.params.recordingKey, body);
    }

    deleteThumbnail(contentId, e) {
        e.stopPropagation();
        this.props.deleteThumbnail(contentId);
    }

    setMetaTags() {
        const {content, channel, attributes} = this.props;
        if (content && content.length > 0 && content[0]) {
            const {t} = this.props;
            let title = '';
            let description;
            let thumbnailUrl = config.metaTags.thumbnailUrl;
            let publisherName;
            let publisherLogoUrl = config.metaTags.publisherLogoUrl;
            let durationString = '';
            let privateContent = false;

            // Make the Recording's title or as a fallback the Channel's title the page's title
            if (content[0].title) {
                title = content[0].title;
            } else if (channel && channel.channelTitle) {
                title = channel.channelTitle;
            }
            // Make the recordings descripton the description for the page or fallback to the channel's description.
            if (attributes && attributes.description) {
                description = attributes.description.replace(/\n/g, ' ');
            } else if (channel && channel.channelDescription) {
                description = channel.channelDescription.replace(/\n/g, ' ');
            }
            // Set the thumbnail to the Recordings thumbnail or as a fallback the channels logo or channel banner
            if (content[0].thumbnail && content[0].thumbnail.cdnLocation) {
                thumbnailUrl = content[0].thumbnail.cdnLocation;
            } else if (channel && channel.channelLogoCdn) {
                thumbnailUrl = channel.channelLogoCdn;
            } else if (channel && channel.channelBanner && channel.channelBannerCdn) {
                thumbnailUrl = channel.channelBannerCdn;
            }
            // Set the publishers name, fallback to GoToStage
            if (channel && channel.channelTitle) {
                publisherName = channel.channelTitle;
            }
            // Set the publishers logo, fallback to GoToStage Logo
            if (channel && channel.channelLogo) {
                publisherLogoUrl = channel.channelLogo;
            }

            if (content[0].duration) {
                const seconds = content[0].duration;
                const duration = moment.duration(seconds, 'seconds').toISOString();
                durationString = `"duration":"${duration}",`;
            }

            if (channel && channel.isLimitedAudience) {
                privateContent = true;
            }

            return (
                <Helmet>
                    <title>{`${title} | GoToStage.com `}</title>
                    <meta name="description" content={description || t('metaTags.watchNow.description')} />
                    <meta property="og:image" content={thumbnailUrl} />
                    <meta name="keywords" content={t('metaTags.keywords')} />
                    <meta name="robots" content={privateContent ? 'noindex' : 'index'} />

                    <script type="application/ld+json">
                        {`
                            {
                              "@context": "http://schema.org",
                              "@type": "VideoObject",
                              "name": "${title} | GoToStage.com ",
                              "description": "${description || t('metaTags.watchNow.description')}",
                              "thumbnailUrl": "${thumbnailUrl}",
                              "uploadDate": "${content[0].createdTime}",
                              ${durationString}
                              "publisher": {
                                "@type": "Organization",
                                "name": "${publisherName || t('metaTags.watchNow.publisherName')}",
                                "logo": {
                                  "@type": "ImageObject",
                                  "url": "${publisherLogoUrl}",
                                  "width": 313,
                                  "height": 60
                                }
                              },
                              "contentUrl": "${window.location.href}",
                              "embedUrl": "${window.location.href}"
                            }
                        `}
                    </script>

                </Helmet>
            );
        }
        return ('');
    }

    setHeader() {
        const self = this;
        // TODO uncomment when theme needed in next iteration.
        /* navRight.push(
            <div className={`${classPrefix}-share-button`}>
                 <ThemeSelector clickTheme={this.themeChangeHandler} clickBanner={this.bannerChangeHandler} />
            </div>
        );*/
        if (this.props.channel) {
            self.props.initHeader({
                channelTheme: `${this.props.channel.channelTheme || 'default'}`,
                showSearch: !this.props.channel.isLimitedAudience,
                searchBarColor: 'black'
            });
        }
    }

    updateFooter() {
        const {t} = this.props;
        const styles = {
            backgroundColor: `${this.props.channel.channelTheme && this.props.channel.channelTheme !== 'default' ? this.props.channel.channelTheme : ''}`,
            color: `${this.props.channel.channelThemeTextColor && this.props.channel.channelTheme !== 'default' ? this.props.channel.channelThemeTextColor : ''}`
        };

        const rightFooter = [
            <span id="terms&conditions" key="terms&conditions"><a
              href={`${config.company.termsOfService}`}
              style={styles} target="_blank"
              rel="noopener"
            >{t('channel.footer.tnc')}</a></span>,
            <span key="privacy"><a
              href={`${config.company.privacyPolicy}`} target="_blank" rel="noopener"
              style={styles}
            >{t('channel.footer.privacy')}</a></span>,
            <span
              key="rights"
              style={styles}
            >&copy; {new Date().getFullYear()} {t('channel.footer.company')} {t('channel.footer.copyright')}</span>
        ];

        this.props.setClassNameFooter({
            classes: 'generic-page-footer',
            styles
        });

        this.props.setRightFooter(rightFooter);
    }

    errorMessageHandled(dataCall, errorCode) {
        const reloadCalls = ['putRecordingTitle', 'putContentAttribute'];
        if ((errorCode === 401) || reloadCalls.includes(dataCall)) {
            window.location.reload();
        }
        if (this.props.contentErrors && this.props.contentErrors.isError) {
            this.props.contentErrorHandled();
        }
    }

    checkErrors() {
        let error = null;
        if (this.props.contentErrors && this.props.contentErrors.isError) {
            const errorObj = {};
            errorObj.error = this.props.contentErrors;
            errorObj.channelKey = (this.props.channelKey) ? this.props.channelKey : null;
            errorObj.content = (this.props.content && this.props.content.length > 0) ? this.props.content[0] : null;
            logger.error('data call error', errorObj);
            error = this.showErrorDialogue(this.props.contentErrors);
        }
        return error;
    }

    showErrorDialogue(errObject) {
        return (<MessageBanner
          show="true"
          type="error"
          errorData={errObject}
          errorHandled={this.errorMessageHandled.bind(this)}
          t={this.props.t}
        />);
    }

    setContentRecommendedData() {
        const contentKey = (this.props.params && this.props.params.recordingKey) ? this.props.params.recordingKey : null;

        if (contentKey && this.props.contentMetaData) {
            const content = this.props.contentMetaData.get(contentKey);
            contentRecommendedData = (content && content.encodedData) ? content.encodedData : null;
        }
    }

    renderSocialShare(facebook = true, linkedin = true, twitter = true) {
        const {t} = this.props;
        const baseUrl = config.app.baseUrl;
        let channelId = null;
        const searchId = genericHelper.findQueryValue('search_id');
        if (this.props.channel && this.props.channel.channelKey) {
            channelId = this.props.channel.channelKey;
        }
        return (
            <div className="wn_content-share">
                <span
                  className="wn_icon wn_icon__offset--attendee wn_content--display"
                >{t('SharedComponents.share-component')}</span>
                <SocialShare
                  channelName={this.props.channel ? this.props.channel.channelTitle : ''}
                  contentKey={this.props.params && this.props.params.recordingKey}
                  channelKey={channelId}
                  identityKey={this.props.identity && this.props.identity.me && this.props.identity.me.id}
                  email={this.props.identity && this.props.identity.me && this.props.identity.me.userName}
                  linkValue={`${baseUrl}/channel/${channelId}/recording/${this.props.params.recordingKey}/watch`}
                  metaImage={this.props && this.props.content &&
                    this.props.content[0].thumbnail && this.props.content[0].thumbnail.location ? this.props.content[0].thumbnail.location : ''}
                  t={this.props.t}
                  title={this.props && this.props.content && this.props.content[0].title ? this.props.content[0].title : ''}
                  page={mixpanelTracker.wnPage}
                  facebook={facebook}
                  linkedIn={linkedin}
                  twitter={twitter}
                  searchId={searchId}
                />
            </div>
        );
    }

    displaySocialShare() {
        if (this.props.channel && !this.props.channel.isLimitedAudience) {
            return this.renderSocialShare();
        } else if (this.props.channel && this.props.channel.isLimitedAudience && this.props.isChannelOwner) {
            return this.renderSocialShare(false, false, false);
        }
        return null;
    }

    render() {
        const {t} = this.props;
        if (this.props.contentsFetching > 0 || this.props.channelProfileFetching > 0) {
            return <OverlaySpinner />;
        }
        if (this.props.content.length === 0) {
            // content not found
            return (
                <div className="wn_no-content">
                    <Image
                      src={`${config.assets.url}/images/catalog/no-content_thumb.png`}
                      style={{margin: 'auto'}}
                      alt="" responsive
                    />
                    <span className="norecordings">{t('watchNow.content.norecording')}</span>
                </div>);
        }
        return (

            <div className="wn_content-center-wrapper">
                {this.checkErrors()}
                {this.showRegistrationModal()}
                {this.setMetaTags()}
                <div className="wn_content-center">
                    <div className="wn_content-header">
                        <div className="wn_content-title">{this.setTitle()}</div>
                        <Link to={`/channel/${this.props.channelKey}`}>
                            <div className="wn_content-logo">{this.setLogo()}
                                <span className="wn_channel-title">{this.setChannelTitle()}</span>
                            </div>
                        </Link>
                    </div>
                    {this.videoFrame()}
                    <div className="wn_content-meta">
                        <div className="wn_content-meta_cnd">
                            <div className="wn_content-category">{this.setCategory()}</div>
                            <div className="wn_content-date">{this.setDate()}</div>
                        </div>
                        {this.displaySocialShare()}
                    </div>
                    <div className="wn_content-detail">
                        <div className="wn_content-description">{this.setDescription()}</div>
                    </div>
                </div>
            </div>
        );
    }
}

WatchNow.propTypes = {
    t: PropTypes.func,
    identity: PropTypes.object,
    initHeader: PropTypes.func,
    initFooter: PropTypes.func,
    channel: PropTypes.object,
    channels: PropTypes.array,
    channelTheme: PropTypes.string,
    channelKey: PropTypes.string,
    channelBannerCdn: PropTypes.string,
    setClassNameFooter: PropTypes.func,
    setClassNameHeader: PropTypes.func,
    params: PropTypes.object,
    getOneContent: PropTypes.func,
    contentsFetching: PropTypes.number,
    channelProfileFetching: PropTypes.number,
    content: PropTypes.array,
    isChannelOwner: PropTypes.bool,
    createCategory: PropTypes.func,
    createThumbnail: PropTypes.func,
    editRecordingTitle: PropTypes.func,
    channelErrors: PropTypes.object,
    contentErrors: PropTypes.object,
    contentErrorHandled: PropTypes.func,
    getContentAttributes: PropTypes.func,
    attributes: PropTypes.object,
    putContentAttributes: PropTypes.func,
    deleteThumbnail: PropTypes.func,
    registerForContent: PropTypes.func,
    registrationInfo: PropTypes.object,
    setRightFooter: PropTypes.object,
    contentMetaData: PropTypes.map,
    attendeeInfo: PropTypes.object
};

export default connect(
    state => ({
        content: state.content.content,
        contentMetaData: (state.recommendations && state.recommendations.contentMetaData) ? state.recommendations.contentMetaData : null,
        registrationInfo: state.content.registrationInfo,
        contentsFetching: state.content.isFetching,
        channelProfileFetching: state.channel.isFetching,
        contentErrors: state.content.error,
        attributes: state.content.attributes,
        channels: state.channel.channels,
        attendeeInfo: state.attendeeInfo
    }),
    dispatch => bindActionCreators(Object.assign({}, HeaderActions, FooterActions, contentActions), dispatch)
)(translate(['translation'])(WatchNow));



// WEBPACK FOOTER //
// ./src/components/watch-now/watch-now.js